import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { FORGET_PASSWORD, SET_NEW_PASSWORD } from "./actionTypes";
import {
  userForgetPasswordSuccess,
  apiError,
  setNewPswSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* userForgetPassword({ payload: { user } }) {
  try {
    const request = yield call(
      axios.post,
      "/security/system-user/password-reset",
      {
        email: user.email,
      }
    );
    if (
      (request.status >= 200 || request.status <= 299) &&
      request.data &&
      request.data.data
    ) {
      yield put(userForgetPasswordSuccess(request.data));
    } else {
      throw request.data;
    }
  } catch (error) {
    let message;
    if (error.request && error.request.status) {
      switch (error.request.status) {
        case 400:
          message = "Invalid data";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.request.data && error.request.data.message)
            message = error.request.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* setNewPsw({ payload: { user, history, pswToken } }) {
  try {
    const request = yield call(
      axios.post,
      "/system-user/password-change",
      {
        password: user.password,
      },
      { headers: { Authorization: `Bearer ${pswToken}` } }
    );
    if (
      (request.status >= 200 || request.status <= 299) &&
      request.data &&
      request.data.data
    ) {
      yield put(setNewPswSuccess(request.data));
      setTimeout(() => {
        history.push("/login");
      }, 2500);
    } else {
      throw request.data;
    }
  } catch (error) {
    let message;
    if (error.request && error.request.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.request.status) {
        case 400:
          message = "Invalid data";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.request.data && error.request.data.message)
            message = error.request.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, userForgetPassword);
}
export function* watchUserPasswordChange() {
  yield takeEvery(SET_NEW_PASSWORD, setNewPsw);
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget), fork(watchUserPasswordChange)]);
}

export default forgetPasswordSaga;
